import { httpClient } from '@/lib/api/client';
import { ENDPOINTS } from '@/lib/api/endpoints';
import type { StoreSettings } from '@/types/domain';

export const settingsRepository = {
  get: () => httpClient.get<StoreSettings>(ENDPOINTS.settings.get),
  update: (data: StoreSettings) => httpClient.put<StoreSettings>(ENDPOINTS.settings.update, data),
  uploadLogo: (file: File) => httpClient.upload<StoreSettings>(ENDPOINTS.settings.uploadLogo, file),
};
